var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-document-mono"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 1.5H3.375C3.17609 1.5 2.98532 1.57902 2.84467 1.71967C2.70402 1.86032 2.625 2.05109 2.625 2.25V15.75C2.625 15.9489 2.70402 16.1397 2.84467 16.2803C2.98532 16.421 3.17609 16.5 3.375 16.5H9.75V12.75C9.75 11.7165 10.5915 10.875 11.625 10.875H15.375V2.25C15.375 2.05109 15.296 1.86032 15.1553 1.71967C15.0147 1.57902 14.8239 1.5 14.625 1.5Z",
    fill: "#989BA2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8749 12.75V16.5L15.3749 12H11.6249C11.426 12 11.2352 12.079 11.0945 12.2197C10.9539 12.3603 10.8749 12.5511 10.8749 12.75Z",
    fill: "#989BA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementList);
export default __webpack_public_path__ + "static/media/icon_settlement_list.49e0bced65b7b5491e9f03bb904a5de7.svg";
export { ForwardRef as ReactComponent };